import {
  useV2DeleteDocumentTemplateMutation,
  useV2RestoreDocumentTemplateMutation,
} from "@generated";
import type { V2DocumentTemplateResource } from "@generated";

export const useDocumentTemplateMutations = () => {
  // v2 infers the account from the auth token — no slug needed.
  const [destroy, destroyState] = useV2DeleteDocumentTemplateMutation();
  const [restoreTemplate, restoreState] =
    useV2RestoreDocumentTemplateMutation();

  return {
    // Archive (soft-delete: the API stamps deleted_at; restore re-activates).
    archive: (id: string) => destroy({ id: id }).unwrap(),

    restore: (id: string) =>
      restoreTemplate({
        id: id,
        // PUT /v2/document-templates/:id/restore-requests restores by id and
        // ignores the body, but v2 swagger marks the JSON:API data body
        // required, so send a minimal one.
        body: {
          data: {
            type: "document-templates",
            id: id,
          } as unknown as V2DocumentTemplateResource,
        },
      }).unwrap(),

    states: { destroyState, restoreState },
  };
};

export default useDocumentTemplateMutations;
